export enum SeasonName {
  HALLOWEEN = 'HALLOWEEN',
}

export const CURRENT_SEASON_NAME: SeasonName | undefined = undefined;
